module.exports = __webpack_public_path__ + "static/media/sf-test-11.71a9c8ee.mp3";